export default "__VITE_ASSET__CfEiHrYP__"